<script>
import swal from 'sweetalert2';
import { DataTable } from 'simple-datatables';

export default {
    methods: {
        deleteProperty(property) {
            swal({
                title: 'Are you sure?',
                text: "You won't be able to undo this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#dd3333',
                confirmButtonText: 'Yes, delete it!',
            })
                .then(reason => {
                    // Dismissed/closed
                    if (reason.hasOwnProperty('dismiss')) {
                        return;
                    }

                    this.$axios
                        .delete(
                            route('admin.properties.delete', {
                                property: property,
                            }),
                        )
                        .then(response => {
                            if (!response.data.status) {
                                swal({
                                    title: 'Error',
                                    text: response.data.error,
                                    type: 'error',
                                }).catch(swal.noop);
                            } else {
                                window.location.reload();
                            }
                        });
                })
                .catch(swal.noop);
        },

        deactivateProperty(property) {
            swal({
                title: 'Are you sure?',
                text: "You can re-activate the property at any time.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#dd3333',
                confirmButtonText: 'Yes, deactivate it!',
            })
                .then(reason => {
                    // Dismissed/closed
                    if (reason.hasOwnProperty('dismiss')) {
                        return;
                    }

                    this.$axios
                        .post(
                            route('admin.properties.deactivate', {
                                property: property,
                            }),
                        )
                        .then(response => {
                            if (!response.data.status) {
                                swal({
                                    title: 'Error',
                                    text: response.data.error,
                                    type: 'error',
                                }).catch(swal.noop);
                            } else {
                                window.location.reload();
                            }
                        });
                })
                .catch(swal.noop);
        },

        activateProperty(property) {
            swal({
                title: 'Are you sure?',
                text: "You can de-activate the property at any time.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#dd3333',
                confirmButtonText: 'Yes, activate it!',
            })
                .then(reason => {
                    // Dismissed/closed
                    if (reason.hasOwnProperty('dismiss')) {
                        return;
                    }

                    this.$axios
                        .post(
                            route('admin.properties.activate', {
                                property: property,
                            }),
                        )
                        .then(response => {
                            if (!response.data.status) {
                                swal({
                                    title: 'Error',
                                    text: response.data.error,
                                    type: 'error',
                                }).catch(swal.noop);
                            } else {
                                window.location.reload();
                            }
                        });
                })
                .catch(swal.noop);
        },
    },

    mounted() {
        const table = document.querySelector('table.table-datatables');
        const datatable = new DataTable(table, {
            'perPage': 25,
            'perPageSelect': false,
        });

        const handlers = () => {
            table.querySelectorAll('a[data-delete]').forEach(a => {
                a.addEventListener('click', () => {
                    const id = a.getAttribute('data-delete');
                    this.deleteProperty(id);
                });
            });

            table.querySelectorAll('a[data-activate]').forEach(a => {
                a.addEventListener('click', () => {
                    const id = a.getAttribute('data-activate');
                    this.activateProperty(id);
                });
            });

            table.querySelectorAll('a[data-deactivate]').forEach(a => {
                a.addEventListener('click', () => {
                    const id = a.getAttribute('data-deactivate');
                    this.deactivateProperty(id);
                });
            });
        };

        datatable.on('datatable.init', handlers);
        datatable.on('datatable.update', handlers)
    },
};
</script>
